import React, { useState } from "react";
import { Tabs } from "antd";
import mobileIcon from "../../../../assets/icons/bx_mobile.svg";
import desktopIcon from "../../../../assets/icons/desktop_mac.svg";
import mobileBackground from "../../../../assets/my-profile.png";
import desktopBackground from "../../../../assets/Desktop-gray.png";
import blonkLogo from "../../../../assets/icons/JobIcons/blonk-logo.png";
import locationPin from "../../../../assets/icons/JobIcons/location-pin.png";
import personRound from "../../../../assets/icons/JobIcons/person-round.png";
import playIcon from "../../../../assets/icons/JobIcons/play.png";
import likeIcon from "../../../../assets/icons/JobIcons/like.png";
import dislikeIcon from "../../../../assets/icons/JobIcons/dislike.png";
import favoriteIcon from "../../../../assets/icons/JobIcons/favorite.png";
import chatIcon from "../../../../assets/icons/JobIcons/chat.png";
import hamburgerIcon from "../../../../assets/icons/JobIcons/charm_menu-hamburger.png";
import wifiBatteryIcon from "../../../../assets/icons/JobIcons/wifi-battery-mobile-icons.png";
import "./PreviewBanner.scss";

const { TabPane } = Tabs;

interface PreviewBannerProps {
  mobileBannerUrl?: string;
  desktopBannerUrl?: string;
}

const PreviewBanner: React.FC<PreviewBannerProps> = ({
  mobileBannerUrl,
  desktopBannerUrl,
}) => {
  const [activeTab, setActiveTab] = useState("desktop");

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  const renderDesktopPreview = () => (
    <div className="preview-container desktop-preview">
      <div className="device-frame desktop-frame">
        <div
          className="desktop-background"
          style={{ backgroundImage: `url(${desktopBackground})` }}
        >
          <div className="website-box">
            <div className="url-bar">
              <span className="url">www.your-website.com</span>
            </div>
            <div className="banner-area">
              {desktopBannerUrl ? (
                <img
                  src={desktopBannerUrl}
                  alt="Desktop Banner"
                  className="banner-image"
                />
              ) : (
                <div className="placeholder-banner">
                  <span>Desktop Banner Preview</span>
                </div>
              )}
            </div>
            <div className="content-lines">
              <div className="content-line"></div>
              <div className="content-line"></div>
              <div className="content-line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderMobilePreview = () => (
    <div className="preview-container mobile-preview">
      <div className="device-frame mobile-frame">
        <div className="mobile-screen">
          <div className="mobile-status-bar">
            <span className="time">9:41</span>
            <img src={wifiBatteryIcon} alt="Status" className="status-icons" />
          </div>

          <div className="mobile-header">
            <img src={hamburgerIcon} alt="Menu" className="hamburger-icon" />
            <span className="header-title">Find jobs</span>
            <img src={chatIcon} alt="Chat" className="chat-icon" />
          </div>

          <div className="job-card">
            <div className="card-background">
              {mobileBannerUrl ? (
                <img
                  src={mobileBannerUrl}
                  alt="Mobile Banner"
                  className="mobile-banner-image"
                />
              ) : null}
            </div>

            <div className="job-overlay">
              <div className="job-info">
                <div className="company-info">
                  <img
                    style={{ height: "25px", marginLeft: 8 }}
                    src={require("../../../../assets/icons/JobIcons/blonk-logo.png")}
                  />{" "}
                  <span style={{ marginLeft: "3px" }}>
                    Business Developer France et Export
                  </span>
                </div>
                <div className="job-details">
                  {/* <span className="briefcase-icon" style={{backgroundImage: "url(http://blonk.co/demo/SOBlonk/assets/icons/JobIcons/Rectangle.png)"}}></span> */}
                  <img
                    style={{ height: "25px", marginLeft: 8 }}
                    src={require("../../../../assets/icons/JobIcons/Rectangle.png")}
                  />
                  <span style={{ marginLeft: "1px" }}>
                    Group viticole Bourgogne et Languedoc
                  </span>
                </div>
                <div className="location-info">
                  <img
                    style={{ height: "25px", marginLeft: 8 }}
                    src={require("../../../../assets/icons/JobIcons/location-pin.png")}
                  />{" "}
                  <span style={{ marginLeft: "10px" }}>
                    Bourgogne ou Languedoc, France
                  </span>
                </div>
                <div className="recruiter-info">
                  <img
                    src={personRound}
                    alt="Profile"
                    className="profile-pic"
                  />
                  <div className="recruiter-details">
                    <span className="recruiter-name">Mark James</span>
                    <span className="recruiter-title">Project Manager</span>
                  </div>
                  <img src={playIcon} alt="Play" className="play-button" />
                </div>
              </div>
            </div>
          </div>

          <div className="action-buttons">
            <img
              src={dislikeIcon}
              alt="Dislike"
              className="action-btn reject"
            />
            <img src={likeIcon} alt="Like" className="action-btn like" />
            <img
              src={favoriteIcon}
              alt="Favorite"
              className="action-btn favorite"
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="preview-banner-section">
      <div className="section-header">
        <h3>Banner Preview</h3>
      </div>

      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        className="preview-tabs"
      >
        <TabPane
          tab={
            <span className="tab-content">
              <img src={desktopIcon} alt="Desktop" className="tab-icon" />
              Desktop
            </span>
          }
          key="desktop"
        >
          {renderDesktopPreview()}
        </TabPane>
        <TabPane
          tab={
            <span className="tab-content">
              <img src={mobileIcon} alt="Mobile" className="tab-icon" />
              Mobile
            </span>
          }
          key="mobile"
        >
          {renderMobilePreview()}
        </TabPane>
      </Tabs>
    </div>
  );
};

export default PreviewBanner;
